import api from '../../lib/api';

export const forgotPassword = data =>
  function get(dispatch) {
    api
      .sendPost('/clients/forgotpassword/', data, (error, response) => {
        console.log(data);
        if (error) return console.error(error);
        if (response.data.hash) {
          return dispatch(forgotPasswordError(response.data));
        }
        return dispatch(forgotPasswordSuccess(response.data));
      });
  };

export const forgotPasswordSuccess = data => ({
  type: 'FORGOT_PASSWORD_SUCCESS',
  data,
});

export const forgotPasswordError = data => ({
  type: 'FORGOT_PASSWORD_ERROR',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Password/forgot.js